import { Switch, Route } from "react-router-dom";
import { LayoutMaster } from '../modules/layout/LayoutMaster';
import { PrivateRoute } from '../components/PrivateRoute';
import PageNotFound from '../pages/PageNotFound';
import { Incidencias } from '../pages/registros/Incidencias';
import { Bienvenido } from '../pages/registros/Bienvenido';
import { Requerimientos } from '../pages/registros/Requerimientos';
import { IncidenciaConcepto } from "../pages/registros/IncidenciaConcepto";
import { DashboardIncidencias } from "../pages/estadisticas/DashboardIncidencias";
import { GestionIncidencias } from "../pages/registros/GestionIncidencias";
import { ReportesIncidencia } from "../pages/Reportes/ReportesIncidencia";
export function PrivateRoutes({ token }) {
    return (
        <>
            {                
                token !== '' && localStorage.getItem('currentLocation') !== '/'
                && (
                    <>
                        <LayoutMaster>
                            <Switch>
                                <PrivateRoute path='/incidencias' component={Incidencias} />
                                <PrivateRoute path='/bienvenido' component={Bienvenido} />
                                <PrivateRoute path='/requerimientos' component={Requerimientos} />
                                <PrivateRoute path='/incidenciaConcepto' component={IncidenciaConcepto} />
                                <PrivateRoute path='/dashboardIncidencias' component={DashboardIncidencias} />
                                <PrivateRoute path='/gestionIncidencias' component={GestionIncidencias} />
                                <PrivateRoute path='/reportesIncidencias' component={ReportesIncidencia} />
                                <Route path="*" component={PageNotFound} />
                            </Switch>
                        </LayoutMaster>
                    </>
                )
            }            
        </>
    )
}